<template>
    <div class="payProjectDeptDataSingle">
        <div class="mainContentWrap">
            <el-row>
                <el-col :span="24">
                    <div class="title">{{deptName}}</div>
                    <div class="unitClass">单位：元</div>
                    <div class="top">
                        <el-row>
                            <el-col :span="9">
                                <div class="top_sum top_sum2">
                                    工程施工总成本
                                    <br/>
                                    {{formatCurrency(sumData.cost)}}
                                </div>
                                <div class="top_sum top_sum1">
                                    <div>
                                        已付款
                                        <br/>
                                        {{formatCurrency(sumData.alreadyPay)}}
                                    </div>
                                    <div>
                                        再付款
                                        <br/>
                                        {{formatCurrency(sumData.allThisPay)}}
                                    </div>
                                    <div>
                                        欠款
                                        <br/>
                                        {{formatCurrency(sumData.debtAmountAfterThisPay)}}
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="echart1" id="echartTop1"></div>
                            </el-col>
                            <el-col :span="5">
                                <div class="echart1" id="echartTop2"></div>
                            </el-col>
                            <el-col :span="5">
                                <div class="echart1" id="echartTop3"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="middle">
                        <div class="title">项目付款分布情况</div>
                        <div class="echarts3Wrap">
                            <div class="echarts3Conents">
                                <div class="echart2" id="echartCenter"></div>
                                <div class="centerTable">
                                    <el-table :data="projectTableData" size="mini" border>
                                        <el-table-column prop="aaaa" label width="140" :resizable="false">
                                            <template slot-scope="scope">
						<span
                                class="tableSpan"
                                :style="{'background': (scope.$index == 0 ? '#f4b183':scope.$index == 1 ? '#f79646':scope.$index == 2 ? '#b65708':'#4bacc6')}"
                        ></span>
                                                <span>{{scope.row[scope.column.property]}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                v-for="(item,index) in projectPayProjectList"
                                                :prop="'column'+index"
                                                :label="item.projectName?item.projectName:''"
                                                :key="index+Math.random()"
                                                show-overflow-tooltip
                                                :resizable="false"
                                        >
                                            <template slot="header">
                                                <el-popover trigger="hover" placement="top">
                                                    <span>{{item.projectName}}</span> <!--hover的内容 -->
                                                    <div slot="reference"
                                                         style="padding: 0px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">
                                                        <span>{{item.projectName}}</span>  <!--显示的内容-->
                                                    </div>
                                                </el-popover>
                                            </template>
                                            <template slot-scope="scope">
                                                {{formatCurrency(scope.row[scope.column.property])}}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="echart_legend">
                                    <span class="colorBox colorBox1"></span><span>工程施工成本</span>
                                    <span class="colorBox colorBox2"></span><span>已付款</span>
                                    <span class="colorBox colorBox3"></span><span>再付款</span>
                                    <span class="colorBox colorBox4"></span><span>欠款</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <el-row>
                            <el-col :span="6">
                                <div class="title">按费用分类工程施工总成本</div>
                                <div class="echart1" id="echartBottomLeft"></div>
                            </el-col>
                            <el-col :span="18">
                                <div class="title">按费用分类付款情况</div>
                                <div class="echart3" id="echartBottomRight"></div>
                                <div class="centerTable">
                                    <el-table :data="projectTableDataBottom" size="mini" border style="width: 100%">
                                        <el-table-column prop="aaaa" label width="130">
                                            <template slot-scope="scope">
                        <span
                                class="tableSpan"
                                :style="{'background': (scope.$index == 0 ?'#f4b183':scope.$index == 1 ? '#f79646':scope.$index == 2 ? '#b65708':'#4bacc6')}"
                        ></span>
                                                <span>{{scope.row[scope.column.property]}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                v-for="(item,index) in projectPayTypeList"
                                                :prop="'column'+index"
                                                :label="item.type"
                                                :key="index"
                                        >
                                            <template
                                                    slot-scope="scope"
                                            >{{formatCurrency(scope.row[scope.column.property])}}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {getPayAnalysisDept} from "../../services/dataCenterAService";

    var echarts = require('echarts/lib/echarts');
    // 引入柱状图
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/pie');
    require('echarts/lib/chart/line');
    // 引入提示框和标题组件
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/title');
    export default {
        name: "payProjectDeptDataSingle",
        data() {
            return {
                echartsData: [],
                deptName: "",
                //第一部分
                sumData: {},
                echartsSumData: [],
                echartsSumDataName: [],

                //中间部分
                projectPayProjectList: [],
                projectTableData: [],
                //底部数据
                echartsSumDataBottom: [],
                projectTableDataBottom: [],
                bottomLeftDataName: [],
                bottomLeftData: [],
                projectPayTypeList: [],
                allEchart32Top: {},
                echartCenter32: null,
                echartBottomLeft32: null,
                echartBottomRight32: null,
            };
        },
        methods: {
            setWrapHeight() {
                let cww = document.getElementsByClassName("payTotalWrap")[0].offsetWidth;
                let ch = Math.ceil((1360 / 990) * cww * 0.98);
                if (document.getElementById("aside")) {
                    ch = 1360;
                    // document.getElementsByClassName(
                    //     "payProjectDeptDataSingle"
                    // )[0].style.width = "1050px";
                }
                document.getElementsByClassName(
                    "payProjectDeptDataSingle"
                )[0].style.height = ch + "px";
                if (this.allEchart32Top) {
                    for (let i in this.allEchart32Top) {
                        if (this.allEchart32Top[i]) {
                            this.allEchart32Top[i].resize()
                        }
                    }
                }
                if (this.echartCenter32) {
                    this.echartCenter32.resize()
                }
                if (this.echartBottomLeft32) {
                    this.echartBottomLeft32.resize();

                }
                if (this.echartBottomRight32) {
                    this.echartBottomRight32.resize();

                }
            },
            search(searchData) {
                let _this = this;
                //查询项目部下的数据
                let params = {};
                if (searchData.enterDate) {
                    params.enterDate = searchData.enterDate;
                }
                if (searchData.projectProcess) {
                    params.projectProcess = searchData.projectProcess;
                }

                if (searchData.deptId) {
                    params.deptId = searchData.deptId;
                }
                getPayAnalysisDept(params)
                    .then(res => {

                        if (res.code === 10000000) {
                            this.deptName = searchData.deptName;
                            //顶部部分数据
                            this.sumData = res.data;
                            // 中间部分数据
                            this.projectPayProjectList = res.data.projectPayProjectList;
                            _this.echartsSumData = [[], [], [], []];
                            _this.echartsSumDataName = [];
                            // 中间柱状图
                            _this.projectPayProjectList.forEach((item, index) => {
                                _this.echartsSumData[0].push(item.cost);
                                _this.echartsSumData[1].push(item.alreadyPay);
                                _this.echartsSumData[2].push(item.allThisPay);
                                _this.echartsSumData[3].push(item.debtAmountAfterThisPay);
                                _this.echartsSumDataName.push(item.projectName);
                            });
                            //中间table表格
                            _this.projectTableData = [
                                {
                                    aaaa: "工程施工成本"
                                },
                                {
                                    aaaa: "已付款"
                                },
                                {
                                    aaaa: "再付款"
                                },
                                {
                                    aaaa: "欠款"
                                }
                            ];
                            _this.echartsSumData.forEach((item, index) => {
                                item.forEach((subItem, subIndex) => {
                                    _this.projectTableData[index]["column" + subIndex] = subItem;
                                });
                            });
                            //  底部数据
                            _this.projectPayTypeList = res.data.projectPayTypeList;
                            // data: ['劳务费', '机械费', '材料费']
                            //底部左边饼状图
                            _this.bottomLeftDataName = [];
                            _this.bottomLeftData = [];
                            _this.projectPayTypeList.forEach((item, index) => {
                                _this.bottomLeftDataName.push(item.type);
                                _this.bottomLeftData.push({name: item.type, value: item.cost});
                            });
                            //底部右边
                            _this.echartsSumDataBottom = [[], [], [], []];
                            _this.projectPayTypeList.forEach((item, index) => {
                                _this.echartsSumDataBottom[0].push(item.cost);
                                _this.echartsSumDataBottom[1].push(item.alreadyPay);
                                _this.echartsSumDataBottom[2].push(item.allThisPay);
                                _this.echartsSumDataBottom[3].push(item.debtAmountAfterThisPay);
                            });
                            //底部右边table表格
                            _this.projectTableDataBottom = [
                                {
                                    aaaa: "工程施工成本"
                                },
                                {
                                    aaaa: "已付款"
                                },
                                {
                                    aaaa: "再付款"
                                },
                                {
                                    aaaa: "欠款"
                                }
                            ];
                            _this.echartsSumDataBottom.forEach((item, index) => {
                                item.forEach((subItem, subIndex) => {
                                    _this.projectTableDataBottom[index][
                                    "column" + subIndex
                                        ] = subItem;
                                });
                            });
                            this.$nextTick(() => {
                                this.setTopData(); //绘制顶部echarts图
                                this.drawCenter(); //中间柱状图
                                this.drawBottomLeft(); //底部左边饼状图
                                this.drawBottomRight(); //底部右边柱状图
                            });
                        } else if (res.code > 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$message.error("系统异常");
                        }
                    })
                    .catch(error => {
                        this.$message.error("系统异常");
                    });
            },
            reset() {
                this.$refs["searchForm"].resetFields();
            },
            setData() {
                let _this = this;
                this.echartsData.forEach((item, index) => {
                    setTimeout(() => {
                        _this.draw(item, index + 1);
                    }, 20);
                });
            },
            //绘制顶部echarts图
            setTopData() {
                let _this = this;
                let data = [
                    {
                        color: ["#f79646", "#4bacc6",],
                        legendData: ["已付款", "欠款"],
                        seriesData: [
                            // {value: parseInt(this.sumData.alreadyPayPct1), name: "已付款"},
                            // {value: parseInt(this.sumData.debtAmountPct1), name: "欠款"}
                            {value: this.sumData.alreadyPay, name: "已付款"},
                            {value: this.sumData.debtAmount, name: "欠款"}
                        ]
                    },
                    {
                        color: ["#f79646", "#72519a", "#4bacc6",],
                        legendData: ["已付款", "拟付款", "欠款"],
                        seriesData: [
                            // {value: parseInt(this.sumData.alreadyPayPct2), name: "已付款"},
                            // {value: parseInt(this.sumData.thisPayPct2), name: "拟付款"},
                            // {value: parseInt(this.sumData.debtAmountPct2), name: "欠款"}
                            {value: this.sumData.alreadyPay, name: "已付款"},
                            {value: this.sumData.thisPay, name: "拟付款"},
                            {value: this.sumData.debtAmountAfterThisPay, name: "欠款"}
                        ]
                    },
                    {
                        color: ["#b65708", "#4bacc6",],
                        legendData: ["再付款", "欠款"],
                        seriesData: [
                            // {value: parseInt(this.sumData.allThisPayPct3), name: "再付款"},
                            // {value: parseInt(this.sumData.debtAmountPct3), name: "欠款"}
                            {value: this.sumData.allThisPay, name: "再付款"},
                            {value: this.sumData.debtAmountAfterThisPay, name: "欠款"}
                        ]
                    }
                ];
                data.forEach((item, index) => {
                    setTimeout(() => {
                        _this.drawTop(item, index + 1);
                    }, 20);
                });
            },
            drawTop(item, index) {
                let _this = this
                console.log(index);
                let idName = "echartTop" + index;
                // let topChart = echarts.init(document.getElementById(idName));
                this.$set(this.allEchart32Top, idName, echarts.init(document.getElementById(idName)))
                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{b} : {d}%"
                    },
                    legend: {
                        orient: "horizontal",
                        // icon: 'circle',
                        bottom: 15,
                        itemHeight: 5,
                        itemWidth: 5,
                        left: "center",
                        data: item.legendData,
                        textStyle: {color: "#415c7b"}
                    },
                    color: item.color,
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "50%",
                            center: ["50%", "40%"],
                            data: item.seriesData,
                            // 设置值域的那指向线
                            labelLine: {
                                normal: {
                                    show: false // show设置线是否显示，默认为true，可选值：true ¦ false
                                }
                            },
                            // 设置值域的标签
                            label: {
                                normal: {
                                    padding: [0, -26],
                                    textStyle: {
                                        fontSize: 10,
                                        // color: 'rgba(0,0,0,0.8)',
                                        color: "#415c7b"
                                    },
                                    // formatter: "{b}\n{d}%"
                                    formatter: function (params) {
                                        let txt = ''
                                        txt = params.name + '\n' + params.percent + '%' + '\n' + _this.formatCurrency(params.value)
                                        return txt
                                    }
                                }
                            }
                        }
                    ]
                };
                this.allEchart32Top[idName].setOption(option);
            },
            //绘制中间柱状图
            drawCenter() {
                // let centerChart = echarts.init(
                //   document.getElementById("echartCenter")
                // );
                //先设置表格的宽度
                let wrapWidth = document.getElementsByClassName("echarts3Wrap")[0]
                    .offsetWidth;
                if (this.projectPayProjectList.length * 150 + 200 < wrapWidth) {
                    document.getElementsByClassName('echarts3Conents')[0].style.width = wrapWidth + 'px'
                } else {
                    let widthC = 200 + this.projectPayProjectList.length * 150
                    document.getElementsByClassName('echarts3Conents')[0].style.width = widthC + 'px'
                }
                this.echartCenter32 = echarts.init(
                    document.getElementById("echartCenter")
                );

                let option = {
                    legend: {
                        data: [],
                        orient: "horizontal",
                        bottom: 0,
                        itemHeight: 0,
                        itemWidth: 0,
                        left: "center"
                    },
                    grid: {
                        left: 140,
                        right: 80,
                        bottom: 0,
                        top: 20,
                        containLabel: true
                    },
                    tooltip: {
                        show: false
                    },
                    color: ["#f4b183", "#f79646", "#b65708", "#4bacc6",],
                    xAxis: {
                        show: false,
                        data: this.echartsSumDataName,
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        }
                    },
                    yAxis: {
                        show: true, // 是否显示
                        type: "value", // 轴类型，默认为 ‘category’
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        },
                        min: 0
                    },
                    series: [
                        {
                            name: "工程施工成本",
                            type: "bar",
                            barWidth: 8, // 柱形的宽度
                            data: this.echartsSumData[0],
                        },
                        {
                            name: "已付款",
                            type: "bar",
                            barWidth: 8, // 柱形的宽度
                            data: this.echartsSumData[1]
                        },
                        {
                            name: "再付款",
                            type: "bar",
                            barWidth: 8, // 柱形的宽度
                            data: this.echartsSumData[2]
                        },
                        {
                            name: "欠款",
                            type: "bar",
                            barWidth: 8, // 柱形的宽度
                            data: this.echartsSumData[3]
                        }
                    ]
                };
                this.echartCenter32.setOption(option);
            },
            //绘制底部左边圆形图
            drawBottomLeft() {
                let _this = this;
                // let bottomLeftChart = echarts.init(
                //   document.getElementById("echartBottomLeft")
                // );
                this.echartBottomLeft32 = echarts.init(
                    document.getElementById("echartBottomLeft")
                );
                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{c}"
                    },
                    legend: {
                        orient: "horizontal",
                        // orient: 'vertical',
                        icon: "circle",
                        bottom: 20,
                        itemHeight: 5,
                        itemWidth: 5,
                        left: "center",
                        data: _this.bottomLeftDataName
                        // data: ['劳务费', '机械费', '材料费']
                    },
                    color: ["#b65708", "#4bacc6", "#8064a2","#f79646"],
                    // b65708
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "40%",
                            center: ["50%", "50%"],
                            data: this.bottomLeftData,
                            // 设置值域的那指向线
                            labelLine: {
                                normal: {
                                    show: false // show设置线是否显示，默认为true，可选值：true ¦ false
                                }
                            },
                            // 设置值域的标签
                            label: {
                                normal: {
                                    padding: [0, -30],
                                    textStyle: {
                                        fontSize: 10,
                                        color: "rgba(0,0,0,0.8)"
                                    },
                                    // formatter: "{c}"
                                    formatter: function (params) {
                                        return _this.formatCurrency(params.value)
                                    }
                                }
                            }
                        }
                    ]
                };
                this.echartBottomLeft32.setOption(option);
            },
            //绘制底部右边圆形图
            drawBottomRight() {
                let _this = this;
                // let bottomRightChart = echarts.init(
                //   document.getElementById("echartBottomRight")
                // );
                this.echartBottomRight32 = echarts.init(
                    document.getElementById("echartBottomRight")
                );
                let option = {
                    legend: {
                        orient: "horizontal",
                        bottom: 5,
                        itemHeight: 8,
                        itemWidth: 8,
                        left: "center"
                    },
                    grid: {
                        left: 140,
                        right: 40,
                        bottom: "36%",
                        top: 10,
                        containLabel: true
                    },
                    tooltip: {
                        show: false
                    },
                    color: ["#f4b183", "#f79646", "#b65708", "#4bacc6",],
                    xAxis: {
                        show:false,
                        // data: ['劳务费', "机械费", "材料费"],
                        data: _this.bottomLeftDataName,
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        }
                    },
                    yAxis: {
                        show: true, // 是否显示
                        type: "value", // 轴类型，默认为 ‘category’
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        },
                        min: 0
                    },
                    series: [
                        {
                            name: "工程施工成本",
                            type: "bar",
                            barWidth: 10, // 柱形的宽度
                            data: this.echartsSumDataBottom[0]
                        },
                        {
                            name: "已付款",
                            type: "bar",
                            barWidth: 10, // 柱形的宽度
                            data: this.echartsSumDataBottom[1]
                        },
                        {
                            name: "再付款",
                            type: "bar",
                            barWidth: 10, // 柱形的宽度
                            data: this.echartsSumDataBottom[2]
                        },
                        {
                            name: "欠款",
                            type: "bar",
                            barWidth: 10, // 柱形的宽度
                            data: this.echartsSumDataBottom[3]
                        }
                    ]
                };
                this.echartBottomRight32.setOption(option);
            },

            //数字用逗号隔开
            formatCurrency(num) {
                num = Number(num)
                num = num.toFixed(2)
                if (num === 0) {
                    return 0;
                } else if (num) {
                    num = num.toString().replace(/\$|\,/g, "");
                    if (num === "" || isNaN(num)) {
                        return 0;
                    }
                    var sign = "";
                    if (num.indexOf("-") !== -1) {
                        sign = "-";
                        num = num.substr(1);
                    }
                    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
                    cents = cents.length > 1 ? cents : "";
                    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
                    if (cents === "") {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    } else {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    }
                    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                        num =
                            num.substring(0, num.length - (4 * i + 3)) +
                            "," +
                            num.substring(num.length - (4 * i + 3));
                    }
                    return sign + num + cents;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .payProjectDeptDataSingle {
        text-align: left;
        overflow: hidden;
        background: #ffffff;
        padding: 0 10px;
        /*height: 1360px;*/
        width: 98%;
        margin: 0 auto;

        .mainContentWrap {
            height: 99%;

            .el-row {
                height: 100%;

                .el-col {
                    height: 100%;

                    .title {
                        text-align: center;
                        font-size: 24px;
                        line-height: 50px;
                        font-weight: 600;
                    }

                    .unitClass {
                        text-align: right;
                        font-size: 20px;
                    }

                    .top {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        height: 21%;
                        /*height: 284px;*/
                        padding-top: 6px;
                        margin: 5px;

                        .el-row {
                            height: 100%;

                            .el-col {
                                height: 100%;

                                .top_sum {
                                    text-align: center;
                                    font-size: 16px;
                                    font-weight: 600;
                                    line-height: 10px;
                                    height: 40%;
                                    background: #bdd0e9;
                                    width: 80%;
                                    margin: 4% auto 4%;
                                }

                                .top_sum2::before {
                                    display: inline-block;
                                    content: "";
                                    height: 60%;
                                    vertical-align: middle;
                                }

                                .top_sum1 {
                                    background: #ffffff;
                                    height: 36%;
                                    margin: 0 auto;
                                    display: flex;
                                    justify-content: space-between;
                                    font-size: 14px;
                                    color: rgba(0, 0, 0, 0.7);
                                }

                                .top_sum1 > div {
                                    width: 29%;
                                    height: 100%;
                                    line-height: 14px;
                                    padding: 0 1%;
                                    word-break: break-all
                                }

                                .top_sum1 > div::before {
                                    display: inline-block;
                                    content: "";
                                    height: 50%;
                                    vertical-align: middle;
                                }

                                .top_sum1 > div:nth-of-type(1) {
                                    background: #f4b183;
                                }

                                .top_sum1 > div:nth-of-type(2) {
                                    background: #00b050;
                                }

                                .top_sum1 > div:nth-of-type(3) {
                                    background: #ffc000;
                                }

                                .echart1 {
                                    height: 100%;
                                }
                            }
                        }
                    }

                    .middle {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        /*height: calc(46% - 10px);*/
                        /*height: 512;*/
                        height: 38%;
                        margin: 10px 5px;
                        position: relative;

                        .title {
                            text-align: left;
                            font-weight: 600;
                            font-size: 16px;
                            line-height: 16px;
                            margin: 10px 0 0px 10px;
                        }

                        .echarts3Wrap {
                            height: calc(100% - 26px);
                            width: 100%;
                            overflow-x: auto;
                            overflow-y: hidden;

                            .echarts3Conents {
                                height: 100%;

                                .echart2 {
                                    width: 100%;
                                    height: calc(100% - 155px - 32px)
                                }

                                .echart_legend {
                                    text-align: center;
                                    position: absolute;
                                    bottom: 10px;
                                    width: 100%;

                                    .colorBox {
                                        display: inline-block;
                                        margin-right: 2px;
                                        width: 8px;
                                        height: 8px;
                                        border-radius: 2px;
                                    }

                                    .colorBox1 {
                                        background: #f4b183;
                                    }

                                    .colorBox2 {
                                        background: #f79646;
                                    }

                                    .colorBox3 {
                                        background: #b65708;
                                    }

                                    .colorBox4 {
                                        background: #4bacc6;
                                    }
                                }
                            }
                        }


                        .centerTable {
                            /*position: absolute;*/
                            /*width: calc(100% - 118px);*/
                            /*top: 64%;*/
                            /*left: 40px;*/
                            padding: 0 80px 0 70px;
                            overflow: hidden;

                            /deep/ .el-table {
                                overflow: hidden;
                            }

                            /deep/ .el-table tr {
                                th {
                                    padding: 0;
                                    background: #ffffff;

                                    .cell {
                                        text-align: center;
                                        height: 30px;
                                        line-height: 30px;
                                        /*overflow: auto;*/
                                        overflow: hidden; /*设置超出的部分进行影藏*/
                                        text-overflow: ellipsis; /*设置超出部分使用省略号*/
                                        white-space: nowrap; /*设置为单行*/
                                        width: 100%;
                                    }
                                }

                                td {
                                    padding: 0;

                                    .cell {
                                        text-align: center;
                                        height: 30px;
                                        line-height: 30px;

                                        .tableSpan {
                                            display: inline-block;
                                            margin-right: 2px;
                                            width: 8px;
                                            height: 8px;
                                            border-radius: 2px;
                                        }
                                    }
                                }

                                td:nth-of-type(1) .cell {
                                    text-align: left;
                                }
                            }
                        }
                    }

                    .bottom {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        height: 31%;
                        /*height: 420px;*/
                        margin: 5px;

                        .el-col {
                            position: relative;
                        }

                        .echart3 {
                            height: calc(100% - 34px);
                        }

                        .centerTable {
                            position: absolute;
                            width: calc(96% - 70px);
                            top: 62%;
                            /*left: 56px;*/
                            left: 80px;

                            /deep/ .el-table tr {
                                th {
                                    padding: 0;
                                    background: #ffffff;

                                    .cell {
                                        text-align: center;
                                        line-height: 22px;
                                        height: 22px;
                                    }
                                }

                                td {
                                    padding: 0;

                                    .cell {
                                        text-align: center;
                                        line-height: 22px;
                                        height: 22px;
                                        padding: 0;
                                        font-size: 12px;

                                        .tableSpan {
                                            display: inline-block;
                                            margin-right: 2px;
                                            width: 8px;
                                            height: 8px;
                                            border-radius: 2px;
                                        }
                                    }
                                }

                                td:nth-of-type(1) .cell {
                                    text-align: left;
                                }
                            }
                        }

                        .el-row {
                            height: 100%;

                            .el-col {
                                height: 100%;

                                .title {
                                    text-align: left;
                                    font-size: 16px;
                                    line-height: 16px;
                                    margin: 10px 0 0 10px;
                                }

                                .echart1 {
                                    height: calc(100% - 36px);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>

